import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getZoomAccessToken } from "../../services/ZoomService";
import { useAuth } from "../../auth/AuthContext";

const OAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { updateZoomToken } = useAuth();

  useEffect(() => {
    const handleAuthorization = async () => {
      try {
        // Extract authorization code
        const queryParams = new URLSearchParams(location.search);
        const authorizationCode = queryParams.get("code");
       // console.log("Authorization code:", authorizationCode);

        if (!authorizationCode) {
          console.error("Authorization code not found.");
          alert("Authorization code not found"); // Redirect to error page
          return;
        }

        // Exchange authorization code for tokens
        const tokenData = await getZoomAccessToken(authorizationCode, null, updateZoomToken);
        //console.log("Token data:", tokenData);

        if (tokenData && tokenData.access_token && tokenData.expires_in) {
          console.log("Setting Zoom token with expiry...");
          const { access_token, refresh_token, expires_in } = tokenData;
          updateZoomToken(access_token, refresh_token, expires_in);

          // Redirect to the Sabbath list page
          navigate("/listSabbathReq");
        } else {
          console.error("Failed to obtain Zoom token.");
          navigate("/error?message=Failed to authorize with Zoom"); // Redirect to error page
        }
      } catch (error) {
        console.error("Error exchanging authorization code for token:", error);
        navigate("/error?message=Authorization failed. Please try again later."); // Redirect to error page
      }
    };

    handleAuthorization();
  }, [location, navigate, updateZoomToken]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <p>Authorizing with Zoom, please wait...</p>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default OAuthCallback;
